import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getBottomSheetHeight = function getBottomSheetHeight(screenHeight, height, maxHeight) {
  // Design spec for BottomSheet full screen height is 99% of the screen height
  var screenHeightPx = "".concat(screenHeight * 0.99, "px");
  if (height === 'content-fit') return {
    maxHeight: maxHeight || screenHeightPx
  };
  if (height === 'full-screen') return {
    height: screenHeightPx
  };
  return {
    height: height
  };
};
var getHeaderProps = function getHeaderProps(_ref) {
  var title = _ref.title,
    subtitleId = _ref.subtitleId,
    labelledBy = _ref.labelledBy,
    describedBy = _ref.describedBy,
    header = _ref.header;
  return header ? _objectSpread({
    'aria-label': title
  }, subtitleId && {
    'aria-describedby': subtitleId
  }) : {
    'aria-labelledby': labelledBy,
    'aria-describedby': describedBy
  };
};
var getStaticProps = function getStaticProps() {
  return {
    position: 'sticky',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'base.surface',
    borderRadius: ['16', '16'],
    boxShadow: 'bottom-m',
    width: '100%',
    bottom: '0',
    role: 'dialog',
    'aria-modal': 'true',
    overflowY: 'auto',
    touchAction: 'none'
  };
};
var getFocusTrapProps = function getFocusTrapProps(_ref2) {
  var visible = _ref2.visible,
    transitionProps = _ref2.transitionProps;
  return _objectSpread({
    width: '100%',
    qM: {
      width: '50%'
    },
    bottom: '0',
    height: '100%',
    position: 'fixed',
    display: 'flex',
    alignItems: 'flex-end',
    open: visible
  }, transitionProps);
};

export { getBottomSheetHeight, getFocusTrapProps, getHeaderProps, getStaticProps };
//# sourceMappingURL=BottomSheet.mappers.js.map
